export default function FailedPage() {
  return (
    <main className="result-shell failed-shell">
      <section className="result-card">
        <div className="result-icon failed-icon">!</div>
        <p className="result-kicker">Verification incomplete</p>
        <h1>Verification Failed</h1>
        <p className="result-copy">
          We could not complete the check. Please try again from your verification link.
        </p>
      </section>
    </main>
  );
}
